import { ProductAttribute, ProductAttributeKeys } from "@wttb/product-configurator";
import { FormProvider, useForm } from "react-hook-form";

import { ChoiceButton } from "@/common/components/form/choice-button";
import { SequentialNumberingForm } from "@/features/product/components/product-attributes/sequential-numbering-attribute/sequential-numbering-form";
import { SingleOption } from "@/features/product/components/product-attributes/single-choice-button-selector";
import { useStoreProduct } from "@/features/product/contexts/product-context";

export function SequentialNumberingAttribute({
  attribute,
  options,
  onChange,
}: {
  attribute: ProductAttribute;
  options: SingleOption[];
  onChange: (valueId: string) => void;
}) {
  const { setCustomConfigValue, config, selectedOptions, setSelectedOptions, setProductConfig } =
    useStoreProduct();
  const methods = useForm<{ sequentialNumberingValue: number }>({
    mode: "onChange",
  });

  const setCustomValue = (value: number) => {
    setCustomConfigValue(ProductAttributeKeys.SequentialNumberingValue, value);
  };

  const handleSelect = (valueId: string) => {
    if (!config?.[attribute.key]) {
      onChange(valueId);
    }
  };

  const handleDeselect = () => {
    if (config?.[attribute.key]) {
      const updatedConfig = { ...config };
      delete updatedConfig?.[ProductAttributeKeys.SequentialNumbering];
      delete updatedConfig?.[ProductAttributeKeys.SequentialNumberingValue];
      setProductConfig(updatedConfig);

      const newSelectedOptions = { ...selectedOptions };
      delete newSelectedOptions?.[ProductAttributeKeys.SequentialNumbering];
      delete newSelectedOptions?.[ProductAttributeKeys.SequentialNumberingValue];
      setSelectedOptions(newSelectedOptions);

      methods.reset({ sequentialNumberingValue: undefined });
    }
  };

  if (!attribute.custom) return;

  return (
    <div className="text-grey-80 grid grid-cols-2 gap-6">
      <FormProvider {...methods}>
        {options.map((option: SingleOption) => (
          <div className="flex flex-col gap-y-5" key={option.id}>
            <ChoiceButton
              {...option}
              onInputChange={handleSelect}
              onClick={handleDeselect}
              key={option.id}
              isChecked={option.value === config![attribute.key]}
              type="radio"
              disabled={false}
            />
            {!!config?.[attribute.key] && (
              <SequentialNumberingForm
                setSequentialNumbering={setCustomValue}
                defaultValue={
                  selectedOptions?.[ProductAttributeKeys.SequentialNumberingValue]
                    ? Number(selectedOptions?.[ProductAttributeKeys.SequentialNumberingValue])
                    : undefined
                }
              />
            )}
          </div>
        ))}
      </FormProvider>
    </div>
  );
}
